// Diagonal watermark laid across the middle of any preview container (parent must be `relative`).
export const Watermark = () => (
  <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden" data-testid="preview-watermark">
    <span className="-rotate-[18deg] whitespace-nowrap text-white/70 font-semibold uppercase tracking-[0.2em] text-[clamp(10px,1.9vw,20px)]"
      style={{ textShadow: "0 1px 3px rgba(0,0,0,0.55), 0 0 12px rgba(0,0,0,0.25)" }}>
      Fine Art by Jason Preview
    </span>
  </div>
);
